const basicStore = {
  namespaced: true,
  state: () => {}
};

export function store() {
  return basicStore;
}
